/** @format */

const signDustLogs = {
  trySignIn: {
    event: 'try_sign_in',
    params: {
      username: '',
      enter_from: 'home',
    },
  },
  signIn: {
    event: 'sign_in',
    params: {
      enter_from: 'home',
    },
  },
  signOut: {
    event: 'sign_out',
    params: {},
  },
  signUp: {
    event: 'sign_up',
    params: {},
  },
};

export default signDustLogs;
